<template>
  <el-form>
    <el-row :gutter="5" justifty="center">
      <el-col :xs="24" :sm="18" :md="12" :lg="12" :xl="12">
        <el-form-item label="Autorizador">
          <el-input tabindex="0" disabled v-model="approvedBy"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5" justifty="center" v-if="status !== '4' && status !== '5'">
      <el-col :xs="24">
        <el-form-item>
          <el-radio-group v-model="authorization">
            <el-radio label="1">Solicitar autorização para fechamento com diferença</el-radio>
            <el-radio label="2">Solicitar reabertura da conferência</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item v-if="status !== '4' && status !== '5'">
      <el-button plain type="info" disabled v-if="status === '6'">Caixa não autorizado</el-button>
      <el-button type="info" @click="request()">{{
        status === '6' ? 'Solicitar novamente' : 'Solicitar'
      }}</el-button>
    </el-form-item>
    <el-form-item v-else-if="status !== '5' && status !== '6'">
      <el-button plain type="info" @click="refresh">Aguardando aprovação</el-button>
    </el-form-item>
    <el-form-item v-else>
      <el-button plain type="info" disabled>Caixa autorizado</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { PdvCashierService } from "@/services/pdv/pdv.cashier.services";
export default {
  props: ['title', 'state', 'type', 'label', 'status'],
  data() {
    return {
      authorization: '1',
      approvedBy: '',
      id: '',
    }
  },
  mounted() {
    const vm = this;
    const loading = vm.$loading(vm.$options.loading);
    PdvCashierService.authorization()
      .then((response) => {
        vm.id = response;
        vm.approvedBy = response.map(x => x.name).join(',');
      })
      .catch((error) => this.$message({ type: "error", duration: 5000, message: error }))
      .finally(() => loading.close());
  },
  methods: {
    open() {
      this.approvedBy = '';
      this.id = '';
    },
    refresh() {
      this.$emit('refresh')
    },
    request() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PdvCashierService.request(vm.authorization)
        .then((response) => {
          vm.$emit('authorization')
          this.$message({ type: "success", duration: 5000, message: 'Solicitação de aprovação enviada com sucesso!' });
        })
        .catch((error) => this.$message({ type: "error", duration: 5000, message: error }))
        .finally(() => loading.close());
    }
  }
}
</script>